export default __webpack_public_path__ + "588e538ee07a475317349e8ee1410d7e.png";